import React from 'react';
import { observer } from 'mobx-react-lite';
import { GameBackside, GameHolder } from '@pascal/pascal-core/table-line';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import {
  FreeBetsWrapper,
  DefaultQueryParams,
  parseQuery,
  useTranslation,
} from '@pascal/pascal-core';
import { GameCardHolderContainer } from '../../containers/gameCardHolderContainer';
import { CardHolderWebView } from '../../components/cardHolderView';
import { CountDown, DealerCards } from '../../components';
import PlayerHands from '../../containers/playerHands';
import ChipsWrapper from '../../containers/chipsWrapper';
import ControlPanel from '../../containers/controlPanel';
import { ShuffleCardsWrapper } from '../../components/shuffleCardWraper';
import { cardsStore } from '../../store/cardsStore';
import WinPopup from '../../components/winPopUp';
import { winningAmountStore } from '../../store/winningAmountStore';
import { TERMINAL_ID } from '../../enums/constants';

export const WebGameMain = observer(() => {
  const { isShuffle } = cardsStore;
  const { winningAmount } = winningAmountStore;
  const { currencyCode } = userInfoStore;
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const isTerminal = +gameId === TERMINAL_ID;

  const t = useTranslation();

  return (
    <GameHolder>
      <GameBackside />
      <div className='turbo-blackjack-wrapper'>
        <div className='tb-game-board'>
          <div className='tb-card-holder'>
            {!isShuffle ? <GameCardHolderContainer innerComp={CardHolderWebView} /> : null}
            {isShuffle ? <ShuffleCardsWrapper /> : null}
            {/* <CardAnimation /> */}
          </div>
          <CountDown isShuffle={isShuffle} />
          {!isShuffle ? (
            <>
              <ChipsWrapper />

              <PlayerHands />

              <DealerCards />

              <ControlPanel />
            </>
          ) : null}
          {winningAmount && !isTerminal ? (
            <WinPopup winningAmount={winningAmount} t={t} currencyCode={currencyCode} />
          ) : null}
        </div>
        <FreeBetsWrapper />
      </div>
    </GameHolder>
  );
});
